/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const DEBOUNCE_TIMEOUT_MS = 300;

export const FETCH_LIMIT = 15;

export const MINIMAL_LENGTH = 2;
